import { createSlice } from '@reduxjs/toolkit';

// Helper function to get tenant from localStorage
const getTenantFromLocalStorage = () => {
  try {
    const tenant = localStorage.getItem('tenant');
    return tenant ? JSON.parse(tenant) : null;
  } catch (_error) {
    // Error handled silently
    return null;
  }
};

// Helper function to save tenant to localStorage
const saveTenantToLocalStorage = (tenant) => {
  try {
    if (tenant) {
      localStorage.setItem('tenant', JSON.stringify(tenant));
    } else {
      localStorage.removeItem('tenant');
    }
  } catch (_error) {
    // Error handled silently
  }
};

const initialState = {
  tenants: [],
  selectedTenant: getTenantFromLocalStorage(),
  loading: false,
  error: null
};

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setTenants: (state, action) => {
      state.tenants = action.payload;
      state.error = null;
    },
    selectTenant: (state, action) => {
      state.selectedTenant = action.payload;
      saveTenantToLocalStorage(action.payload);
      state.error = null;
    },
    clearTenant: (state) => {
      state.selectedTenant = null;
      localStorage.removeItem('tenant');
    },
    setTenantLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTenantError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setTenantFromLocalStorage: (state) => {
      state.selectedTenant = getTenantFromLocalStorage();
    }
  }
});

export const {
  setTenants,
  selectTenant,
  clearTenant,
  setTenantLoading,
  setTenantError,
  setTenantFromLocalStorage
} = tenantSlice.actions;

// Selectors
export const selectSelectedTenant = (state) => state.tenant.selectedTenant;
export const selectTenants = (state) => state.tenant.tenants;
export const selectTenantLoading = (state) => state.tenant.loading;
export const selectTenantError = (state) => state.tenant.error;

export default tenantSlice.reducer;
